const getRateActionPlan = (
  product,
  isBrochureToggleEvent,
  code,
  travelAgency,
  roomDescriptions,
  productsCodesAddedToBrochure,
  isCallingFromTripConfig,
) => {
  const doShowChatGPTImprovedRoomDescription =
    travelAgency?.settings?.doShowChatGPTImprovedRoomDescription || false;

  const path = window.location.pathname;
  const isBlockedPage =
    path.includes('/checkout') || path.includes('/confirmation') || path.includes('/search');

  const noAdditionalInfo = !product.additional_info;
  const hasCode = !!code;
  const isBrochureToggle = !!isBrochureToggleEvent;

  let doCallGetProductInfo =
    (noAdditionalInfo && hasCode) || (noAdditionalInfo && !hasCode && isBrochureToggle);

  if (isBlockedPage && isCallingFromTripConfig) doCallGetProductInfo = false;

  const doCallEnhanceDesc =
    doShowChatGPTImprovedRoomDescription &&
    code &&
    !product?.rooms?.[0]?.htmlDescription &&
    (!roomDescriptions[code] || !roomDescriptions[code].description);

  const doAddToBrochure =
    !productsCodesAddedToBrochure.includes(product.code) && isBrochureToggleEvent;

  const details = {
    doCallGetProductInfo,
    doCallEnhanceDesc,
    doAddToBrochure,
  };
  return details;
};

export default getRateActionPlan;
